import styled from "styled-components";

export const Wrapper = styled.section`
  border-radius: 24px;
  overflow: hidden;
  background-color: #0da5a7;
  background-image: linear-gradient(90deg, #0DA5A7 0%, #B2A1F6 100%);
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 640px) {
    min-height: 500px;
    border-radius: 18px;
  }
`;

export const Wave = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 140px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50% 50% 0 0;
  
`;

export const Content = styled.div`
  position: relative;
  
  z-index: 2;
  padding: 28px 36px 8px;
  text-align: center;
  flex-shrink: 0;

  @media (max-width: 640px) {
    padding: 24px 18px 6px;
  }
`;

export const Title = styled.h2`
  color: #102b40;
  font-size: clamp(28px, 2.4vw, 36px);
  font-weight: 700;
  line-height: 1.15;
  overflow-wrap: anywhere;
`;

export const Description = styled.p`
  margin-top: 14px;
  color: #102b40;
  font-size: clamp(18px, 1.6vw, 26px);
  line-height: 1.45;
  overflow-wrap: anywhere;
`;

export const Note = styled.p`
  margin-top: 12px;

  color: #102b40;

  font-size: clamp(15px, 1.2vw, 20px);
  font-style: italic;
  line-height: 1.4;
`;

export const BannerImageWrap = styled.div`
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 28px;

  @media (max-width: 640px) {
    padding: 12px 12px 0;
  }
`;

export const BannerArt = styled.div`
  position: relative;
  width: min(68%, 620px);
  aspect-ratio: 557 / 304;

  @media (max-width: 768px) {
    width: min(94%, 620px);
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

export const CloudButton = styled.button`
  position: absolute;
  left: ${({ $left }) => $left};
  top: ${({ $top }) => $top};
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
  padding: 0;
  z-index: 3;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
 
  }

  &:focus-visible {
    outline: 3px solid white;
    outline-offset: 4px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 30000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 46px 64px 32px;
  background: rgba(0, 0, 0, 0.32);

  @media (max-width: 900px) {
    align-items: flex-start;
    padding: 18px;
    overflow-y: auto;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const SchemeModalCard = styled.div`
  position: relative;
  z-index: 30000;
  width: min(calc(100vw - 140px), 1600px);
  overflow: visible;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.24);

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 52px;
    width: 7px;
    height: 50px;
    background: #f5b335;
  }

  @media (max-width: 900px) {
    width: 100%;
    overflow: hidden;
  }

  @media (max-width: 480px) {
    border-radius: 14px;
  }
`;

export const SchemeModalClose = styled.button`
  position: absolute;
  top: 38px;
  right: 48px;
  z-index: 2;
  width: 52px;
  height: 52px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }

  &:focus-visible {
    outline: 3px solid #f5b335;
    outline-offset: 4px;
    border-radius: 999px;
  }

  @media (max-width: 900px) {
    top: 22px;
    right: 22px;
    width: 42px;
    height: 42px;
  }


  @media (max-width: 480px) {
    top: 14px;
    right: 14px;
    width: 36px;
    height: 36px;
  }
`;

export const SchemeModalBody = styled.div`
  padding: 42px 52px 38px;

  @media (max-width: 900px) {
    padding: 28px 22px 30px;
  }

  @media (max-width: 480px) {
    padding: 22px 16px 24px;
  }
`;

export const SchemeModalTitle = styled.h2`
  margin: 0 84px 28px 0;
  color: #005f5b;
  font-size: clamp(32px, 2.35vw, 42px);
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
  overflow-wrap: anywhere;

  @media (max-width: 560px) {
    margin: 0 48px 20px 0;
    font-size: clamp(24px, 8vw, 32px);
  }
`;

export const SchemeIntro = styled.p`
  margin: 0 0 26px;
  color: #10305b;
  font-size: clamp(17px, 1.12vw, 20px);
  font-weight: 500;
  line-height: 1.5;
  overflow-wrap: anywhere;
`;

export const SchemeModalGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(520px, 1.05fr);
  gap: 50px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    gap: 28px;
  }
`;

export const SchemeContent = styled.div`
  color: #10305b;
`;

export const SchemeSectionTitle = styled.h3`
  display: inline-block;
  margin: 0 0 16px;
  color: #005f5b;
  font-size: clamp(22px, 1.48vw, 26px);
  font-weight: 800;
  line-height: 1.15;
  text-decoration: underline;
  text-underline-offset: 5px;
`;

export const SchemeList = styled.ul`
  margin: 0 0 30px;
  padding-left: 28px;
  color: #10305b;
  font-size: clamp(17px, 1.14vw, 20px);
  font-weight: 500;
  line-height: 1.48;

  li + li {
    margin-top: 3px;
  }

  li {
    overflow-wrap: anywhere;
  }

  @media (max-width: 560px) {
    padding-left: 20px;
    font-size: 16px;
  }
`;

export const DocumentsList = styled(SchemeList)`
  margin-bottom: 28px;
  columns: 2;
  column-gap: 44px;

  li {
    break-inside: avoid;
  }

  @media (max-width: 760px) {
    columns: 1;
  }
`;

export const ApplyButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 14px;
  min-height: 60px;
  border-radius: 999px;
  background: #006760;
  padding: 0 30px;
  color: #ffffff;
  font-size: clamp(18px, 1.18vw, 22px);
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  max-width: 100%;
  text-align: center;
  line-height: 1.3;
  white-space: normal;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: #005752;
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 3px solid #f5b335;
    outline-offset: 4px;
  }

  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    min-height: 52px;
    padding: 10px 18px;
  }
`;

export const ComingSoonBackdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border-radius: 20px;
  background:
    radial-gradient(circle at center, rgba(255, 214, 232, 0.94), rgba(255, 232, 241, 0.74) 45%, rgba(255, 232, 241, 0.54)),
    rgba(255, 223, 237, 0.74);
  cursor: pointer;

  @media (max-width: 480px) {
    padding: 14px;
  }
`;

export const ComingSoonBanner = styled.div`
  width: min(92%, 560px);
  border: 1px solid rgba(208, 63, 126, 0.22);
  border-radius: 18px;
  background: linear-gradient(135deg, #fff7fb 0%, #ffd6e8 52%, #ffc1dc 100%);
  box-shadow: 0 18px 52px rgba(159, 38, 91, 0.28);
  padding: 38px 36px;
  color: #8b1449;
  text-align: center;

  strong {
    display: block;
    margin-bottom: 10px;
    font-size: clamp(34px, 3.6vw, 56px);
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1;
    text-transform: uppercase;
  }

  span {
    display: block;
    color: #5f1237;
    font-size: clamp(16px, 1.35vw, 22px);
    font-weight: 600;
    line-height: 1.45;
  }

  @media (max-width: 560px) {
    padding: 30px 22px;
  }
`;

export const VideoPreview = styled.div`
  position: relative;
  margin-top: 0;
`;

export const VideoThumbWrap = styled.div`
  position: relative;
  aspect-ratio: 595 / 362;
  background: transparent;

  a {
    position: absolute;
    inset: 10px 12px 10px 11px;
    width: calc(100% - 23px);
    height: calc(100% - 20px);
    border: 0;
    display: block;
    &:focus-visible {
      outline: 3px solid #005856;
      outline-offset: 3px;
    }
  }
`;

export const VideoFrameImage = styled.img`
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none;
`;

export const VideoThumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  filter: brightness(0.62);
`;

export const PreviewPlayButton = styled.button`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 86px;
  height: 86px;
  transform: translate(-50%, -50%);
  border: 0;
  border-radius: 999px;
  background: #ffffff;
  color: #10305b;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    left: 36px;
    top: 26px;
    border-left: 27px solid #10305b;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
  }

  @media (max-width: 560px) {
    width: 60px;
    height: 60px;

    &::before {
      left: 26px;
      top: 19px;
      border-left-width: 19px;
      border-top-width: 12px;
      border-bottom-width: 12px;
    }
  }
`;

export const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
